//import { Facility, init_Institution, Institution } from "./APIInterface";

import { AppEnvSetting } from "../ts/common";

export interface App {
  id: string;
  name: string;
}

export const ORG_SHARED_DATA = "sharedData";
export interface UserOrganizations {
  [APP_ID: string]: Record<string, Record<string, string>>;
}

export interface UserApplications {
  [APP_ID: string]: Record<string, string>;
}

export interface ApplicationCategories {
  [CATEGORY_ID: string]: Record<string, string>;
}

interface Global {
  [key: string]: any
}

export interface UserData {
  id: string;
  country: string;
  defaultLanguage: string;
  timezone: string;
  global: Global;
  email: string;
  firstName: string;
  lastName: string;
  isScimUser: boolean;
  phoneNumber: string;
  userType: string | null;
  applications: UserApplications;
  organizations: UserOrganizations;
  applicationCategories: ApplicationCategories;
  emailVerificationFlag?: boolean | null;
  passwordResetFlag?: boolean | null;
  isActive?: boolean;
  lastEmailValidationDate?: any;
  lastPasswordResetDate?: any;
  lastLoginDate?: any;
}

//export type UserProvisionStatus = "" | "Approved" | "Pending" | "Rejected" 

export interface UserSearchQuery{
  email: string;
  country: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  applicationId: string;
  userProvisionStatus: string;
}

export interface UserSearchResult {
  id: string;
  country: string;
  defaultLanguage: string;
  email: string;
  firstName: string;
  lastName: string;
  userType: string;
  isActive: boolean;
  isFederated: boolean;
  organizations: UserOrganizations | string[];
}

export const init_newUserDataObj = (): UserData => { return ({
    id: '',
    country: AppEnvSetting.defaultCountry,
    defaultLanguage: 'en-US',
    timezone: '',
    global: {},
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    isScimUser: false,
    userType: '',
    applications: {},
    organizations: {},
    applicationCategories: {},
    emailVerificationFlag: false,
    passwordResetFlag: false,
    isActive: true,
  });}

export const updateUserData = {
  setTopLevelField: (
    setUserDataState: (newState: UserData) => void,
    currentState: UserData,
    field: keyof UserData,
    data: any
  ) => {
    setUserDataState({ ...currentState, [field]: data });
  },
  setGlobalField: (
    setUserDataState: (newState: UserData) => void,
    currentState: UserData,
    field: keyof Global,
    data: any
  ) => {
    setUserDataState({
      ...currentState,
      global: { ...currentState.global, [field]: data },
    });
  },
  setApplicationCategoryData: (
    setUserDataState: (newState: UserData) => void,
    currentState: UserData,
    newApplicationCategories: ApplicationCategories
  ) => {
    setUserDataState({
      ...currentState,
      applicationCategories: { ...newApplicationCategories },
    });
  },
  setOrganizationData: (
    setUserDataState: (newState: UserData) => void,
    currentState: UserData,
    newOrgs: UserOrganizations
  ) => {
    setUserDataState({ ...currentState, organizations: { ...newOrgs } });
  },
  setSingleOrganizationData: (
    setUserDataState: (newState: UserData) => void,
    currentState: UserData,
    orgId: string,
    newOrg: Record<string, Record<string, string>>
  ) => {
    setUserDataState({ ...currentState, organizations: { ...currentState.organizations, [orgId]: {...newOrg} } });
  },
  setSingleApplication: (
    setUserDataState: (newState: UserData) => void,
    currentState: UserData,
    orgId: string,
    appID: string,
    appData: Record<string, string>
  ) => {
    setUserDataState({
      ...currentState,
      organizations: {
        ...currentState.organizations,
        [orgId]: {
          ...currentState.organizations[orgId],
          [appID]: { ...appData },
        },
      },
    });
  },
  setInit: (setUserDataState: (newState: UserData) => void) => {
    setUserDataState({ ...init_newUserDataObj() });
  },
  isInit: (currentState: UserData): boolean => {
    return JSON.stringify(currentState) === JSON.stringify(init_newUserDataObj());
  },
};

export const isInitUserData = (currentState: UserData): boolean => {
  return JSON.stringify(currentState) === JSON.stringify(init_newUserDataObj());
};

export enum UserUpdateAction {
  TOPLEVEL = 'TOPLEVEL',
  GLOBAL = 'GLOBAL',
  ORGANIZATIONS = 'ORGANIZATIONS',
  SINGLEORG ='SINGLEORG',
  SINGLEAPPCLAIMS = 'SINGLEAPPCLAIMS',
  APPLICATIONCATEGORIES = 'APPLICATIONCATEGORIES',
  SINGLEAPP = 'SINGLEAPP',
  REPLACEUSER = 'REPLACEUSER',
  RESET = 'RESET',
  USERTYPE = 'USERTYPE'
}

export function userDataReducer(
  state: UserData,
  action: {
    type: UserUpdateAction;
    payload: {
      field?:
        | keyof Global
        | keyof UserData
        | keyof UserOrganizations
        | keyof UserApplications
        | keyof ApplicationCategories;
      data: any;
    };
  }
): UserData {
  const { type, payload } = action;

  if (
    payload.field === undefined &&
    (type === UserUpdateAction.TOPLEVEL ||
      type === UserUpdateAction.GLOBAL ||
      type === UserUpdateAction.SINGLEAPP)
  ) {
    console.log(`${type} is missing field attribute!`);
    return { ...state };
  }

  switch (type) {
    case UserUpdateAction.TOPLEVEL:
      return {
        ...state,
        [payload.field!]: payload.data,
      };
    case UserUpdateAction.GLOBAL:
      return {
        ...state,
        global: {
          ...state.global,
          [payload.field!]: payload.data,
        },
      };
    case UserUpdateAction.ORGANIZATIONS:
      return {
        ...state,
        organizations: { ...payload.data },
      };
    case UserUpdateAction.SINGLEORG:
        return {
            ...state,
            organizations: {
              ...state.organizations,
          [payload.field!]: {
            ...payload.data.orgData
              },
            },
        applications: {
          ...payload.data.globalAppData
        }
      }
    case UserUpdateAction.SINGLEAPP:
      if (payload.data.globalApp) {
        return {
          ...state,
          applications: {
            ...state.applications,
            [payload.field!]: {
              ...state.applications?.[payload.field!],
              ...payload.data.appData
            }
          }
          };
      } else {
      return {
        ...state,
        organizations: {
          ...state.organizations,
          [payload.field!]: {
            ...state.organizations[payload.field!],
            [payload.data.appId]: { ...payload.data.appData },
          },
        },
      };
      }
    case UserUpdateAction.SINGLEAPPCLAIMS:
      if (payload.data.isGlobal) {
        return {
          ...state,
          applications: {
            ...state.applications,
            [payload.data.appId]: {
              ...state.applications[payload.data.appId],
              [payload.data.appClaim]: payload.data.appValue
            }
          }
        }
      } else {
    return {
        ...state,
        organizations: {
          ...state.organizations,
          [payload.field!]: {
            ...state.organizations[payload.field!],
            [payload.data.appId]: { ...state.organizations[payload.field!][payload.data.appId], [payload.data.appClaim]: payload.data.appValue },
          },
        },
        };
    }
    case UserUpdateAction.APPLICATIONCATEGORIES:
      return {
        ...state,
        applicationCategories: {
          ...state.applicationCategories,
          [payload.field!]: { ...payload.data },
        },
      };
    case UserUpdateAction.USERTYPE:
      return {
        ...state,
        userType: payload.data
      };
    case UserUpdateAction.REPLACEUSER:
      return {
        ...payload.data,
      };
    case UserUpdateAction.RESET: {
      return { ...init_newUserDataObj() };
    }
  }
}
